import { apiEndpointManager } from '../services/apiEndpointManager';
import { setBackendReachable } from './backendReachability';

/**
 * Check real connectivity by pinging the backend(s).
 * navigator.onLine is unreliable — this does real requests with timeout.
 * Multi-endpoint (Fase 2 failover): online = ALGÚN backend responde.
 */
export async function isActuallyOnline(): Promise<boolean> {
  if (!navigator.onLine) return false;
  const reachable = await apiEndpointManager.anyReachable();
  // El veredicto se APUNTA (2026-09-11): antes se usaba para este guardado y
  // se tiraba, así que el resto de la app seguía creyéndose online y sus
  // pantallas se iban a la red a esperar. Ahora gobierna el modo de la app.
  setBackendReachable(reachable);
  return reachable;
}
